import { t } from "@web-monorepo/i18n/macro";
import { IconX } from "@web-monorepo/dds-icons";
import styles from "./EditHeader.module.css";

type EditCloseButtonProps = {
  onClick: VoidFunction;
};

function EditCloseButton({ onClick }: EditCloseButtonProps) {
  return (
    <button
      type="button"
      data-name="edit_header:edit_close_button:ideas_close_icon"
      className={styles.closeButton}
      onClick={onClick}
      aria-label={t`Close edit modal`}
    >
      <IconX />
    </button>
  );
}

type ToolkitCreateHeaderProps = {
  close: VoidFunction;
  title?: string;
};

export default function ToolkitCreateHeader({ close, title }: ToolkitCreateHeaderProps) {
  const headerTitle = title || t`New`;

  return (
    <div className={styles.container}>
      <EditCloseButton onClick={close} />
      <h2 className={styles.title}>{headerTitle}</h2>
    </div>
  );
}
